import React, { useState } from 'react';
import { ReactComponent as AlertIcon } from '../../assets/icons/alert.svg';
import classes from './index.module.scss';

const AlertMessage = ({ alertMessage, spaces, isClosed, styleClass, title, showCloseIcon = true}) => {

  const [show, setShow] = useState(true)

  const onClose = () => {
    setShow(false);
    isClosed && isClosed(true);
  }

  return (
    <>
      {show && alertMessage &&
        <div className={`${classes.Alert_Message} ${spaces} ${classes[styleClass]}`}>
        {title && 
          <div className={classes.Alert_Message_Title}>
            <h3>{title}</h3>
          </div>
        }
          <div className={classes.Alert_Message_Body}>
              <AlertIcon />
              <div dangerouslySetInnerHTML={{__html: alertMessage}} />
          { showCloseIcon && <div className={`${classes.Alert_Message_Close_Button} close-button`} onClick={onClose}>x</div> }
          </div>
        </div>
      }
    </>
  )
}

export default AlertMessage;